<template lang="pug">
  v-app#inspire
    //- v-navigation-drawer(v-model='drawerRight', app='', clipped='', right='')
      v-list(dense='')
        v-list-item(@click.stop='floatPanelRight = !floatPanelRight')
          v-list-item-action
            v-icon mdi-exit-to-app
          v-list-item-content
            v-list-item-title Open Temporary Drawer
    v-content
      v-container
        router-view
        //- v-row(justify='center', align='center')
        //-   v-col
    v-app-bar(app='', clipped-right='', color='#043343', dark='')
      v-app-bar-nav-icon(@click.stop='drawer = !drawer')
      v-spacer
      v-toolbar-title 
        //- .d-none.d-sm-flex día seleccionado
        v-row(justify='center')
          v-col 
            div Atlas COVID-19
          //- v-btn(color='primary', dark='', @click.stop='showDialogDays = true')
            div(v-show="daySelected.date") {{daySelected.date | date-format-string}}
            div(v-show="!daySelected.date") Selecciona un día
          //- v-dialog(v-model='showDialogDays', max-width='290')
            v-card
              v-card-title.headline Selecciona un día:
              v-card-text
                v-radio-group(v-model='daySelected', :mandatory='false')
                  div(@click='showDialogDays = false')
                    v-radio(v-for="obj in nationalConfirmed", 
                            :label='obj.date', :value='obj')
              v-card-actions
                v-spacer
                v-btn(color='green darken-1', text='', @click='showDialogDays = false')
                  | Cerrar

      v-spacer
      a(href="https://www.bsigeonet.com.mx", target="blank")
        v-avatar
          img(alt='BSI', src='./assets/logo.png')
      //- v-app-bar-nav-icon(@click.stop='drawerRight = !drawerRight')
    v-navigation-drawer(v-model='drawer', app='')
      v-list(dense='')
        //- v-list-item(@click.stop='floatPanelLeft = !floatPanelLeft')
          v-list-item-action
            v-icon mdi-exit-to-app
          v-list-item-content
            v-list-item-title Menú izquierdo
        v-list-item(@click="goTo('home')")
          v-list-item-action
            v-icon mdi-home
          v-list-item-content
            v-list-item-title Inicio
              //- router-link(:to="{name:'home'}") Inicio
        v-list-item(@click="goTo('map')")
          v-list-item-action
            v-icon mdi-map
          v-list-item-content
            v-list-item-title Mapa dinámico
              //- router-link(:to="{name:'map'}") 
        v-list-item(@click="goTo('gallery')")
          v-list-item-action
            v-icon mdi-camera-burst
          v-list-item-content
            v-list-item-title Mapas temáticos
        v-list-item(@click="goTo('statistical-report')")
          v-list-item-action
            v-icon mdi-chart-line
          v-list-item-content
            v-list-item-title Informe estadístico
        v-list-item(@click="goTo('economic-effects-report')")
          v-list-item-action
            v-icon mdi-chart-pie
          v-list-item-content
            v-list-item-title Efectos económicos
    v-navigation-drawer(v-model='floatPanelLeft', fixed='', temporary='')
      v-content
        v-container.fill-height(fluid='')
    //- v-navigation-drawer(v-model='floatPanelRight', fixed='', right='', temporary='')
    v-footer.white--text(app='', color='blue-grey')
      a.link-footer(href="https://www.bsigeonet.com.mx", target="blank")
        span BSI
      v-spacer
      span Todos los derechos reservados
      span &nbsp;
      span © 2020
</template>

<script>
// import dataService from '@/services/data'

export default {
  props: {
    source: String
  },
  // computed: {
  //   menuSelected() {
  //     return this.$store.getters.getMenuSelected()
  //   }
  // },
  data: () => ({
    drawer: false,
    drawerRight: false,
    floatPanelRight: false,
    floatPanelLeft: false
    // nationalConfirmed: [],
    // daySelected: {},
    // showDialogDays: false
  }),
  name: 'App',

  components: {
    // HelloWorld
  },
  methods: {
    goTo(name) {
      this.drawer = false
      this.$router.push({ name: name })
    }
  },
  created() {
    // console.log('recuperando datos de inicios...')
    // dataService.listNationalConfirmed().then(res => {
    //   console.log(res)
    //   this.nationalConfirmed = res.object
    //   if (this.nationalConfirmed.length > 0) {
    //     this.daySelected = this.nationalConfirmed[0]
    //   }
    // })
  }
}
</script>

<style>
.link-footer span {
  color: white !important;
}

.word-break-all {
  word-break: break-word;
}
</style>
